"use strict";

/******************************************************
 *                  EDIT ROW ACTIONS DIRECTIVE
 *
 * This directive will add a cell with edit buttons on a line if some condition is fullfilled.
 * Custom callback functions for editing and deleting element.
 *
 ********************************************************/

angular.module("app").directive("tchEditRowActions", function () {
	return {
		restrict: "A",
		templateUrl: "common/directives/tchEditRowActions/tchEditRowActions.html",
		replace: true,
		scope: {
			conditionFullfilledFunction: "&tchEditRowActions",
			editAction: "&tchEditRowEditAction",
			deleteAction: "&tchEditRowDeleteAction"
		},
		link: function(scope, elt, attrs) {
			if (attrs.tchEditRowEditAction) {scope.showEdit = true;}
			if (attrs.tchEditRowDeleteAction) {scope.showDelete = true;}
		}
	};
})
;